// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1bK7D","info":"Note_info__2wVOr","note":"Note_note__NsPmt","actions":"Note_actions__3k3JV"};